import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Text } from "components";
import CreateHeader from "./CreateHeader";
import PathCard from "./pathPicker/PathCard";
import ComingSoonStrip from "./pathPicker/ComingSoonStrip";
import { Sparkle, Pencil } from "./icons";
import "./create.css";

const Create = () => {
  const navigate = useNavigate();

  const pick = (mode, route) => {
    navigate(route);
  };

  return (
    <div className="cg-page surface-manager">
      <CreateHeader />
      <main className="cg-main">
        <div className="cg-stage">
          <div className="cg-head">
            <Text variant="eyebrow" tone="accent" className="cg-eyebrow">New game</Text>
            <Text variant="h1" className="cg-h1">Let's build your Groupardy game</Text>
            <Text variant="body" tone="muted" className="cg-sub">Pick how you want to make it. You can always tweak everything later.</Text>
          </div>

          <div className="cg-paths">
            <PathCard
              featured
              iconClass="ai"
              icon={<Sparkle size={24} />}
              badge={<span className="cg-badge teal">Free in beta</span>}
              title="Generate with AI"
              desc="Answer a few quick questions and we'll write a complete, custom board — ready to play in minutes."
              bullets={[
                "Questions written from scratch for your theme",
                "Categories & difficulty tuned to your room",
                "Every answer fact-checked before it hits the board",
              ]}
              cta={
                <Button variant="cta" fullWidth startIcon={<Sparkle size={17} />}
                        onClick={() => pick("ai", "/create/ai")}>
                  Start with AI
                </Button>
              }
              fineprint={<>Free while in beta · about 3 minutes to build</>}
            />

            <PathCard
              iconClass="diy"
              icon={<Pencil size={22} />}
              badge={<span className="cg-badge neutral">Always free</span>}
              title="Do it yourself"
              desc="Write your own questions, your way. Full control over every category, clue, and wager."
              bullets={[
                "Build the board clue by clue",
                "Set your own categories and values",
                "Total creative control, no limits",
              ]}
              cta={
                <Button variant="secondary" fullWidth startIcon={<Pencil size={16} />}
                        onClick={() => pick("manual", "/create/manual")}>
                  Build it myself
                </Button>
              }
              fineprint={<>Free forever · go at your own pace</>}
            />
          </div>

          <ComingSoonStrip />
        </div>
      </main>
    </div>
  );
};

export default Create;
